import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MainPageStyle.css"

interface Props{
    tag: string;
    name: string;
    token: string;
    loggedState: number;
    setloggedState: React.Dispatch<React.SetStateAction<number>>;
}

function MainPage({tag,name,token,loggedState,setloggedState}:Props){ 

    const [longitude, setLongitude] = useState("")
    const [latittude, setLatitude] = useState("")
    const [description, setDescription] = useState("")
    const [sender, setSender] = useState("")
    const [duration, setDuration] = useState("")

    const navigate = useNavigate();

    useEffect(() => {
      if (loggedState === 0) {
        navigate("/"); // Leitet zur gewünschten Seite weiter, wenn tag nicht gesetzt ist
      }
    }, [tag, navigate]);


    const onButtonClick = () => {
        handleLogin(longitude, latittude, description, sender, duration);
        setloggedState(0);
    }

    const handleLogin = async (longitude:string, latitude: string,description: string, sender: string, duration: string) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueInfo/Server/AddCoordinate.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              longitude,
              latitude,
              description,
              sender,
              duration,
            }),
          });
          


          if (response.ok) {
            //const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            console.log('Erfolgreich gesendet');
            navigate("/")
          } else {
            //const data = await response.json();
            //console.log(data);
            console.error('Fehler Response:', response.statusText);
          }
        } catch (error) {
          console.error('Fehler beim senden:', error);
        }
      };


    return <div className="mainContainer">
        <button className="settings-button" onClick={() => navigate("/ChangePassword")}>Passwort ändern</button>

        <div className="titleContainer">
            <h2>Neue Koordinate für {name}:</h2>
        </div>
        <br />
        <div className="inputContainer">
          <label>Längengrad/Longitude:</label>
            <input
                value={longitude}
                placeholder="Längengrad/Longitude"
                onChange={ev => setLongitude(ev.target.value)}
                className="inputBox" />
        </div>
        <br />
        <div className={"inputContainer"}>
          <label>Breitengrad/Latitude:</label>
            <input
                value={latittude}
                placeholder="Breitengrad/Latitude"
                onChange={ev => setLatitude(ev.target.value)}
                className="inputBox" />
        </div>
        <br />
        <div className={"inputContainer"}>
          <label>Beschreibung:</label>
            <input
                value={description}
                placeholder="Beschreibung"
                onChange={ev => setDescription(ev.target.value)}
                className="inputBox" />
        </div>
        <br />
        <div className={"inputContainer"}>
          <label>Ersteller:</label>
            <input
                value={sender}
                placeholder="Ersteller"
                onChange={ev => setSender(ev.target.value)}
                className="inputBox" />
        </div>
        <br />
        <div className={"inputContainer"}>
          <label>Dauer in Tagen:</label>
            <input
                value={duration}
                placeholder="Dauer"
                onChange={ev => setDuration(ev.target.value)}
                className="inputBox" />
        </div>
        <br />
        <div className="inputContainer">
            <input
                className="inputButton"
                type="button"
                onClick={onButtonClick}
                value={"Senden"} />
        </div>
        
    </div>
};

export default MainPage;